import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/swiper-bundle.css";
import "./AboutInstructor.css";
import defaultImage from "../../assets/images/default-image.png";
import { fetchInstructorsSingle } from "../../redux/slice/InstructorSlice";
import { CalenderAvailabilityData } from "../../redux/slice/CalenderSlice";
import { Routers } from "../../routes/Constant";

export const AboutInstructor = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const calendarRef = useRef(null);
  const swiperRef = useRef(null);
  const [event, setEvents] = useState("");

  const { instructorsdetails, instructorsFilter } = useSelector(
    (state) => state.instructors
  );
  const Availability = useSelector((state) => state.calender.calender);
  const Events = Availability?.calendar_data;

  const [selectedInstructorIndex, setSelectedInstructorIndex] = useState(0);

  const handleDateClick = (info) => {
    const clickedDate = new Date(info.dateStr).toLocaleDateString("en-US");

    const isBooked = Events.some(
      (event) =>
        new Date(event.start).toLocaleDateString("en-US") === clickedDate
    );

    if (isBooked) {
      alert("This date is already booked!");
    } else {
      navigate(Routers.Progress);
      const newEvent = {
        title: "Book Now",
        start: info.date,
        end: info.date,
        allDay: true,
        description: "Click to book now!",
      };

      Events.push(newEvent);

      setEvents([...Events]);

      calendarRef.current.getApi().refetchEvents();
    }
  };

  useEffect(() => {
    const instructorId = params?.id?.split("_").pop();
    dispatch(fetchInstructorsSingle(params.id));
    dispatch(CalenderAvailabilityData(instructorId));
  }, [dispatch, params.id]);

  const changeInstructorHandler = (id) => {
    dispatch(fetchInstructorsSingle(id));
    navigate(`/xcsfvt/more-info/${id}`);
  };

  return (
    <section className="aboutInstructor_section">
      <Container>
       

        <div className="aboutInstructor--inner">
          <div className="instructor_list">
            {instructorsFilter?.length > 0 ? (
              <Swiper
                slidesPerView={5}
                spaceBetween={5}
                navigation={true}
                centeredSlides={true}
                modules={[Navigation]}
                className="mySwiper"
                ref={swiperRef}
                breakpoints={{
                  575: { slidesPerView: 1, spaceBetween: 10 },
                  768: { slidesPerView: 3, spaceBetween: 10 },
                  992: { slidesPerView: 3, spaceBetween: 10 },
                  1200: { slidesPerView: 5, spaceBetween: 10 },
                }}
              >
                {instructorsFilter[0]?.data?.map((instructor, index) => (
                  <SwiperSlide key={instructor.id}>
                    <div
                      className="d-flex other_instructor_list"
                      onClick={() => changeInstructorHandler(instructor.id)}
                    >
                      <div className="text-center">
                        <div className="instructorimg_list_wrapper">
                          <img
                            src={
                              instructor.profile_image
                                ? `https://keyzi.com.au/keyzi-admin/public/${instructor.profile_image}`
                                : defaultImage
                            }
                            alt={instructor.name}
                          />
                        </div>
                        <p>{instructor.name}</p>
                        <h6
                          className={
                            instructor.status === "active"
                              ? "text-success"
                              : "text-danger"
                          }
                        >
                          {instructor.status}
                        </h6>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            ) : (
              <p>Loading instructor data...</p>
            )}
          </div>

          <div className="calender-wrapper">
            <FullCalendar
              ref={calendarRef}
              initialView="timeGridWeek"
              plugins={[
                dayGridPlugin,
                bootstrap5Plugin,
                timeGridPlugin,
                listPlugin,
                interactionPlugin,
              ]}
              events={Events}
              dateClick={handleDateClick}
              selectable={true}
              dayHeaderContent={({ date }) => {
                const dayName = date.toLocaleDateString("en-US", {
                  weekday: "short",
                }); // Get the weekday
                const day = date.getDate(); // Get the day of the month
                const month = date.toLocaleDateString("en-US", {
                  month: "short",
                }); // Get the abbreviated month
                return `${dayName} ${day}/${month}`;
              }}
              headerToolbar={{
                left: "prev,next today",
                center: "title",
                right: "timeGridWeek,dayGridMonth",
              }}
              contentHeight="500px"
            />
          </div>
        </div>
      </Container>
    </section>
  );
};
